import type React from 'react';
import type { ReactNode } from 'react';

interface TabPaneProps {
  name: string;
  id?: string;
  children?: ReactNode;
}

const TabPane: React.FC<TabPaneProps> = ({ children, id }) => {
  return <div id={id}>{children}</div>;
};

export default TabPane;
